import React from 'react';

const StatsSection: React.FC = () => {
  return (
    <section 
      id="impact" 
      className="gm-stats-section"
    >
      <div className="container gm-impact-copy">
        <h1>
          IN 2023, GOODBYE MALARIA IMPACTED THE LIVES OF 
          <span className="gm-stats-number"> 4,203,355</span> PEOPLE IN SOUTHERN AFRICA.
        </h1>
      </div>
    </section>
  );
};

export default StatsSection;
